import type { BrandKey } from '@jotta/config/brand'
import type { Locale } from '@jotta/i18n'
import type { FC } from 'react'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'
import { MediamarktPrivacy } from './MediamarktPrivacy'

export function PrivacySwitch({
  brand,
  locale,
  Fallback,
}: {
  brand: BrandKey
  locale: Locale
  Fallback?: FC
}) {
  switch (brand) {
    case 'MEDIAMARKT':
    case 'LETS_GO':
      return <MediamarktPrivacy locale={locale} />
    case 'JOTTACLOUD':
    case 'ONLIME_WL':
    case 'ELGIGANTEN':
    case 'PHONERO':
    case 'HALEBOP':
    case 'ELKO':
    case 'TELIA_CLOUD':
    case 'GIGANTTI':
    case 'OBOS':
    case 'TEST':
    case 'SATURN':
    case 'ELKJOP':
    case 'GET':
    case 'TDC_NO':
    case 'COMHEM':
      return Fallback ? <Fallback /> : undefined
    default:
      return exhaustiveGuard(brand)
  }
}
